/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import { formatDate, formatCurrency } from "utils";
import SoftBox from "components/SoftBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell";
import { AssetHandoverRecordService } from "services/asset-handover-record";

const renderData = (items, setDataTable) =>
  items.map((item) => ({
    id: item._id,
    documentNumber: item.documentNumber,
    documentDate: item.documentDate,
    decisionNumber: item.decisionNumber,
    handoverLocation: item.handoverLocation,
    totalOriginalCost: formatCurrency.format(item.totalOriginalCost || 0),
    createdAt: formatDate(item.createdAt),
    action: <ActionCell item={item} setDataTable={setDataTable} />,
  }));

const tableData = {
  columns: [
    { Header: "Số biên bản", accessor: "documentNumber" },
    { Header: "Ngày lập", accessor: "documentDate" },
    { Header: "Số quyết định", accessor: "decisionNumber" },
    { Header: "Địa điểm bàn giao", accessor: "handoverLocation" },
    { Header: "Tổng nguyên giá", accessor: "totalOriginalCost" },
    { Header: "Ngày tạo", accessor: "createdAt" },
    { Header: "Actions", accessor: "action", sorted: false },
  ],
  rows: [],
};

export default function AssetHandoverRecord() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({ sortBy: "createdAt", sortType: "desc" });
  const [paginationData, setPaginationData] = useState({ page: 1, count: 0, size: 10 });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await AssetHandoverRecordService.getPaginate({
        ...query,
        page: paginationData.page,
        limit: paginationData.size,
      });

      const { items, paginate } = response.data || response;

      setPaginationData((prev) => ({
        ...prev,
        count: paginate?.count || 0,
        size: paginate?.size || 10,
      }));

      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items || [], setDataTable),
      }));
    } catch (error) {
      setDataTable((prev) => ({ ...prev, rows: [] }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            query={query}
            table={dataTable}
            loading={loading}
            setQuery={setQuery}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}
